// Job-specific gender options with 性別不問 instead of その他
export const JOB_GENDER_OPTIONS = [
  { value: "1", label: "男性" },
  { value: "2", label: "女性" },
  { value: "3", label: "性別不問" },
];
